module.exports = __webpack_public_path__ + "static/media/man.1fc2d465.jpg";